module.exports = __webpack_public_path__ + "static/media/messageSend.db50979c.svg";